<template>
    <div class="skeleton">
       <h3>Lorem Ipsum</h3>
       <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Ipsa, animi at itaque qui consequatur saepe aspernatur veritatis asperiores voluptatibus voluptas aliquid quia doloribus cumque delectus fugit repellat nihil ratione placeat?</p>
       <b-row>
        <b-col cols="11" class="input-form">
        <b-form>
            <b-form-group id="input-1-group" label="cx" label-for="input-1" >
                <b-form-input id="input-1" type="text" placeholder="Lorem, ipsum dolor."></b-form-input>   
            </b-form-group>
        </b-form>
       </b-col>
       <b-col>
        <font-awesome-icon icon="question" class="question-icon"/>
       </b-col>
       </b-row>
       <b-row>
        <b-col cols="11" class="input-form">
        <b-form>
            <b-form-group id="input-1-group" label="cx" label-for="input-1" >
                <b-form-input id="input-1" type="text" placeholder="Lorem, ipsum dolor."></b-form-input>   
            </b-form-group>
        </b-form>
       </b-col>
       <b-col>
        <font-awesome-icon icon="question" class="question-icon"/>
       </b-col>
       </b-row>
       <b-row>
        <b-col cols="11" class="input-form">
        <b-form>
            <b-form-group id="input-1-group" label="cx" label-for="input-1" >
                <b-form-input id="input-1" type="text" placeholder="Lorem, ipsum dolor."></b-form-input>   
            </b-form-group>
        </b-form>
       </b-col>
       <b-col>
        <font-awesome-icon icon="question" class="question-icon"/>
       </b-col>
       </b-row>
       <b-row>
        <b-col cols="11" class="input-form">
        <b-form>
            <b-form-group id="input-1-group" label="cx" label-for="input-1" >
                <b-form-input id="input-1" type="text" placeholder="Lorem, ipsum dolor."></b-form-input>   
            </b-form-group>
        </b-form>
       </b-col>
       <b-col>
        <font-awesome-icon icon="question" class="question-icon"/>
       </b-col>
       </b-row>
       <b-row>
        <b-col cols="11" class="input-form">
        <b-form>
            <b-form-group id="input-1-group" label="cx" label-for="input-1" class="label">
                <b-form-input id="input-1" type="text" placeholder="Lorem, ipsum dolor."></b-form-input>   
            </b-form-group>
        </b-form>
       </b-col>
       <b-col>
        <font-awesome-icon icon="question" class="question-icon"/>
       </b-col>
       </b-row>
       <button type="button" class="btn btn-primary">
            Calculate
       </button>
       <div class="animation"></div>
       </div>
    </template>
    
    
    <script>
    export default {
        name: "CalculationMainSkeleton",
        data(){
            return{
                labels: {}
            }
        },
        methods: {

        },
        mounted(){

        }
    }
    </script>
    
    <style lang="scss" scoped>
    .skeleton {
        h3 {
            font-size: 1.4rem;
            font-weight: 700;
            margin-bottom: 1rem;
            padding-right: 150px;   
            filter:  blur(5px);
        }
        p {
            font-weight: 400;
            font-size: 1.1rem;
            filter:  blur(5px);
        }
        .input-form {
            margin-top: 20px;
            margin-bottom: 20px;
            filter:  blur(5px);
        }
        .question-icon {
            border: 5px solid rgb(20, 170, 245);
            background-color: rgb(20, 170, 245);;
            color: white;
            font-size: 2.5rem;
            border-radius: 50%;
            filter:  blur(5px);
        }
        button {
            filter: grayscale(0.5) blur(10px);
        }
    
        .animation {
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-image: linear-gradient(100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255,
                        255, 255, 0) 80%);
                background-repeat: no-repeat;
                background-size: 100px 100%;
                background-position: -10% 0;
                animation: shine 0.8s infinite;
            }
    }
    @keyframes shine {
        to {
            background-position: 130% 0;
        }
    }
    </style>